// extracted by mini-css-extract-plugin
export default {"title":"_b05bd8a3"};